"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiGet = exports.handlePromiseErrors = void 0;
var helpers_1 = require("./helpers");
/**
 * Check HTTP promise response for server error response (non 2XX status) and reject promise is error
 *
 * @param promise the HTTP promise to check for HTTP status code of 2XX for success
 *
 * @returns promise for the HTTP connection with catch supporting error
 */
var handlePromiseErrors = function (promise) {
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    promise.then(function (response) {
        if (response.ok) {
            promiseInfo.resolver(response);
        }
        else {
            promiseInfo.rejecter(response);
        }
        return response;
    }).catch(function (error) {
        promiseInfo.rejecter(error);
    });
    return promiseInfo.promise;
};
exports.handlePromiseErrors = handlePromiseErrors;
/**
 * Make a GET for retrieving data from a server
 *
 * @param url the url string of the resource on the server
 *
 * @returns a promise that will resolve with the response from the server or reject if network/server error
 */
var apiGet = function (url) {
    return (0, exports.handlePromiseErrors)(fetch(url, {
        headers: {
            'Content-Type': 'application/json',
        },
    }));
};
exports.apiGet = apiGet;
